module.exports = __webpack_public_path__ + "img/logo-white.35f8ccaa.png";